import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import LatestProviderDetails from '@/plugins/graphql/queries/latest-provider.gql';
import PageListFetcher from '@/helpers/entities/classes/facebook/PageListFetcher';
import { ConsoleLogger } from '@/helpers/entities/classes/logger/ConsoleLogger';
import { FacebookLoginProvider } from '@/helpers/entities/classes/providers/FacebookLoginProvider';
import CurrentUserActivePageIds from '@/plugins/graphql/queries/v2/current-user-active-page-ids.gql';
import activeFbPageByApp from '@/plugins/graphql/queries/v2/active-fb-page-by-app.gql';
// Initialize class FacebookLoginProvider
const FbProvider = new FacebookLoginProvider();
let FacebookPagesFetch = class FacebookPagesFetch extends Vue {
    constructor() {
        super(...arguments);
        this.pages = [];
        this.pagination = {};
        this.requestOnFlight = false;
        this.activeFbPageIds = [];
        this.activeFbPageByApp = '';
        this.defaultEndpoint = 'me?fields=accounts{picture{url},access_token,id,name}';
    }
    async refetchQueries() {
        this.fetchFacebookPages(this.providerLatest.token, this.defaultEndpoint, 'default');
        await this.$apollo.queries.activeFbPageIds?.refetch();
        await this.$apollo.queries.activeFbPageByApp?.refetch();
    }
    get queryOnFlight() {
        return this.requestOnFlight;
    }
    hasSelectedPage(selectedPage) {
        const { pages } = this;
        this.pages = pages.filter((page) => {
            return page === selectedPage;
        });
    }
    async fetchFacebookPages(token, endpoint, requestType) {
        const facebookPages = new PageListFetcher(token, endpoint, requestType);
        this.requestOnFlight = true;
        try {
            await facebookPages
                .fetch()
                .then((result) => {
                const pages = result.data;
                const { pagination } = result;
                this.pages = pages;
                this.pagination = pagination;
            })
                .finally(() => {
                this.requestOnFlight = false;
            });
        }
        catch (error) {
            const logger = new ConsoleLogger();
            logger.error(error.message);
        }
    }
    pageId(url) {
        if (this.pagination !== {}) {
            return url.split('/')[4];
        }
        return null;
    }
    buildPaginationUrl(url, cursor) {
        if (this.pagination !== {}) {
            return `${this.pageId(url)}/accounts?pretty=0&fields=picture{url},access_token,id,name&limit=25&${cursor}`;
        }
        return null;
    }
    get afterCursor() {
        if (this.pagination !== {}) {
            return `after=${this.pagination.cursors.after}`;
        }
        return null;
    }
    get beforeCursor() {
        if (this.pagination !== {}) {
            return `before=${this.pagination.cursors.before}`;
        }
        return null;
    }
    goToNextPage() {
        this.fetchFacebookPages(this.providerLatest.token, this.buildPaginationUrl(this.pagination.next, this.afterCursor), 'page');
    }
    goToPreviousPage() {
        this.fetchFacebookPages(this.providerLatest.token, this.buildPaginationUrl(this.pagination.previous, this.beforeCursor), 'page');
    }
    get previousEndpoint() {
        return this.buildPaginationUrl(this.pagination.previous, this.beforeCursor);
    }
    get nextEndpoint() {
        return this.buildPaginationUrl(this.pagination.next, this.afterCursor);
    }
    render() {
        // resolve to lint issue
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                pages: this.pages,
                queryOnFlight: this.queryOnFlight,
                currentUserActivePageIds: this.activeFbPageIds,
                pagination: this.pagination,
                goToNextPage: this.goToNextPage,
                goToPreviousPage: this.goToPreviousPage,
                refetchQueries: this.refetchQueries,
                userActivePageId: this.activeFbPageByApp,
            });
        }
    }
};
FacebookPagesFetch = __decorate([
    Component({
        apollo: {
            providerLatest: {
                query: LatestProviderDetails,
                result(result) {
                    const provider = result.data.providerLatest;
                    this.fetchFacebookPages(provider.token, this.defaultEndpoint, 'default');
                },
                fetchPolicy: 'network-only',
            },
            activeFbPageIds: {
                query: CurrentUserActivePageIds,
                result(data) {
                    return data.activeFbPageIds;
                },
                fetchPolicy: 'network-only',
            },
            activeFbPageByApp: {
                query: activeFbPageByApp,
                variables() {
                    return {
                        appUuid: this.$route.params.appUuid,
                    };
                },
                result(data) {
                    return data.activeFbPageByApp;
                },
                skip() {
                    return !this.$route.params.appUuid;
                },
                fetchPolicy: 'no-cache',
            },
        },
        mounted() {
            // Call #initialize function to append facebook sdk into DOM head
            FbProvider.initialize();
        },
    })
], FacebookPagesFetch);
export default FacebookPagesFetch;
